"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummariseAttributionFlowsResponseSchema = exports.SummariseAttributionFlowsQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
// Flow related
exports.SummariseAttributionFlowsQuerySchema = (0, core_1.StrictObject)({
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    country: typebox_1.Type.Optional(core_1.CountrySchema),
    token: typebox_1.Type.Optional(ruby_1.AttributionEventTokenSchema),
    keyword: typebox_1.Type.Optional(ruby_1.AttributionEventKeywordSchema),
    ...core_1.DateFilterFields,
});
exports.SummariseAttributionFlowsResponseSchema = typebox_1.Type.Object({
    flows: typebox_1.Type.Array((0, core_1.StrictObject)({
        from: (0, core_1.Nullable)(ruby_1.AttributionEventNameSchema),
        to: (0, core_1.Nullable)(ruby_1.AttributionEventNameSchema),
        count: core_1.CountSchema,
    })),
});
